import { IOrder } from '../../../interfaces/bookingContext';
import { useTranslation } from 'react-i18next';
import React from 'react';

const GuestsList = ({ item }: { item: IOrder }) => {
  const { t } = useTranslation();

  const StringGuests = () => {
    const child = item.ageOfChildren.filter((child) => child >= 3).length;
    const infant = item.ageOfChildren.filter((child) => child < 3).length;
    let str = `${item.NoOfAdults} ${t('adults')}`;
    child && (str += ` + ${child} ${child > 1 ? t('children') : t('child')}`);
    infant && (str += ` + ${infant} ${child > 1 ? t('infants') : t('infant')}`);

    return <>{str}</>;
  };

  return <StringGuests />;
};

export default GuestsList;
